import React from "react";
import { Outlet, Navigate } from "react-router-dom";

export default function PrivateRoutes() {
  let userid = localStorage.getItem("authToken") == null ? false : true;
  return <>{userid ? <Outlet /> : <Navigate to="/" />};</>;
}
